import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

/**
 * Builds the callApi config for the reasons-for-visit endpoint.
 */
export function buildReasonsForVisitConfig(): ApiCallConfig {
  return {
    method: HTTP_METHODS.GET,
    endpoint: INTERNAL_API_ENDPOINTS.REASONS_FOR_VISIT,
  };
}
